export enum BookkeepingItemSortProperty {
  Amount = 'amount',
  Date = 'date',
}
